import { UseFormReturn } from 'react-hook-form';

import { SessionPrepInfo } from 'features/sessions/config/types';
import {
  useNextSessionUpdateMutation,
  useParticipantProfileNoteUpdateMutation,
} from 'features/sessions/hooks';
import { hasDirtyFields } from 'features/sessions/utils';

export const useNextSessionUpdate = (
  formMethods: UseFormReturn<SessionPrepInfo>
) => {
  const { nextSessionAppointment, coachingClientNote } =
    formMethods.getValues();

  const nextSessionMutation = useNextSessionUpdateMutation(
    nextSessionAppointment.coachingSessionId
  );

  const profileNoteMutation = useParticipantProfileNoteUpdateMutation({
    noteId: coachingClientNote?.noteId,
    coachingSessionId: nextSessionAppointment.coachingSessionId,
  });

  const onMutate = async (nextSession: SessionPrepInfo) => {
    const { dirtyFields } = formMethods.formState;
    const { coachingClientNote, ...nextSessionFields } = dirtyFields;

    const isNextSessionDirty = hasDirtyFields(nextSessionFields);
    const isClientNoteDirty = hasDirtyFields(coachingClientNote);

    const { text, dashboardLink } = nextSession.coachingClientNote;
    isClientNoteDirty &&
      (await profileNoteMutation.mutateAsync({
        text,
        dashboardLink,
      }));

    isNextSessionDirty && (await nextSessionMutation.mutateAsync(nextSession));
  };

  return onMutate;
};
